module.exports = __webpack_public_path__ + "static/media/cross.51a9841e.svg";